function localFeaturedSelectionPayload(file) {
    if (!(file instanceof File)) {
        return null;
    }

    return {
        mediaKind: 'image',
        finalUrl: null,
        filename: file.name || null,
        crop: null,
    };
}

function mountSimpleFeaturedMediaField(root) {
    if (root.dataset.simpleFeaturedMediaMounted === 'true') {
        return;
    }

    root.dataset.simpleFeaturedMediaMounted = 'true';

    const selectionInput = root.querySelector('[data-simple-featured-media-selection]');
    const fileInput = root.querySelector('input[type="file"]');

    if (!(selectionInput instanceof HTMLInputElement) || !(fileInput instanceof HTMLInputElement)) {
        return;
    }

    fileInput.addEventListener('change', () => {
        const file = fileInput.files?.[0] ?? null;
        const payload = localFeaturedSelectionPayload(file);

        selectionInput.value = payload ? JSON.stringify(payload) : '';
    });
}

export function registerSimpleFeaturedMediaFields() {
    document.querySelectorAll('[data-simple-featured-media-field="true"]').forEach((root) => {
        mountSimpleFeaturedMediaField(root);
    });
}
